import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials, logOut } from '../store/authSlice';
import { RootState } from '../store/store';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AUTOSTREAM_API,
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.token;

        if (token) headers.set('authorization', `Bearer ${token}`);

        return headers
    },
});

const baseQueryWithReAuth: any = async (args: string, api: BaseQueryApi, extraOptions: any) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        api.dispatch(logOut());
    }

    if (result?.error?.status === 403) {
        const refreshResult = await baseQuery("/auth/refresh", api, extraOptions);

        if (refreshResult?.data) {
            const user = (api.getState() as RootState).auth.user;
            api.dispatch(setCredentials({ ...refreshResult.data, user }));

            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logOut());
        }
    }

    return result;
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['Vehicle', 'Profile', 'Seller', 'PendingSeller', 'Buyer', 'PendingBuyer', 'Common', 'Auction', 'AuctionItem', 'AuctionStatus', 'EligibleVehicles','VehicleAuctionHistory'],

    endpoints: () => ({})
});

